import { render } from "./QrReaderPage.vue?vue&type=template&id=cc708ae8&scoped=true"
import script from "./QrReaderPage.vue?vue&type=script&lang=js"
export * from "./QrReaderPage.vue?vue&type=script&lang=js"

import "./QrReaderPage.vue?vue&type=style&index=0&id=cc708ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc708ae8"]])

export default __exports__